import { render } from "./P073.vue?vue&type=template&id=30c9cf0e&scoped=true"
import script from "./P073.vue?vue&type=script&lang=js"
export * from "./P073.vue?vue&type=script&lang=js"

import "./P073.vue?vue&type=style&index=0&id=30c9cf0e&scoped=true&lang=css"

import exportComponent from "/home/sage/workspace/sageprice-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30c9cf0e"]])

export default __exports__